import * as React from 'react'
import { useRef, useState } from 'react'

import './Upload.scss'
import UploadInputWithPreview from './Uploaders/UploadInputWithPreview'
import UploadTakeAPicture from './Uploaders/UploadTakeAPicture'

const Uploader = ({ upload, value, fullWidth, uploading = false, onClick, onChange }: Uploader.IProps) => {
  const uploadInput: React.Ref<HTMLInputElement> = useRef(null)
  const [errors, setErrors] = useState([])
  const [addingFiles, setAddingFiles] = useState(false)

  const reset = () => {
    upload.clear()
    if (uploadInput?.current?.value) uploadInput.current.value = null
    onChange(upload.isMultiple() ? [] : null)
  }

  const handleClick = () => {
    uploadInput.current.click()

    if (onClick && typeof onClick === 'function') onClick()
  }

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setAddingFiles(true)
    const data = await upload.addFileList(event.currentTarget.files)

    if (data.errors.length > 0) {
      // For now we will only show the first error until a decent UX can be created
      setErrors([data.errors[0]])
    }

    onChange(upload.isMultiple() ? [...value, ...data.files] : data.files[0])

    if (uploadInput?.current?.value) uploadInput.current.value = null
    setAddingFiles(false)
  }

  const handleErrorClose = (closedError: Upload.DirectorConstraintError) => {
    setErrors((state) => state.filter((error) => error.id !== closedError.id))
  }

  const props = {
    ref: uploadInput,
    upload,
    value,
    errors,
    fullWidth,
    uploading,
    addingFiles,
    onClick: handleClick,
    onChange: handleChange,
    onReset: reset,
    onErrorClose: handleErrorClose,
  }

  if (upload.config.type === 'takeAPicture') {
    return <UploadTakeAPicture {...props} />
  }

  return <UploadInputWithPreview {...props} />
}

export default Uploader
